<div class="hdr"><h2 mat-dialog-title>Details Diagram</h2></div>

<mat-dialog-content>
  @if (showError) {
    <p class="error"><mat-icon fontIcon="error" class=""/><span>An error occurred while generating the graph.</span></p>
  } @else {
    <h3>Diagram</h3>
    <div [appMermaid]="diagram"></div>
    <h3>Workflow</h3>
    <div [innerHTML]="formatted"></div>
  }

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matButton="filled" type="button" mat-dialog-close cdkFocusInitial>Close</button>
</mat-dialog-actions>
